import { render } from "./ProposalSubmissionView.vue?vue&type=template&id=9801e002"
import script from "./ProposalSubmissionView.vue?vue&type=script&lang=js"
export * from "./ProposalSubmissionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__